import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
  padding-left:250px;

`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;
  margin: 50px auto;

  .ui.dropdown .menu .item {
    display: flex;
  }

  .ui.form .fields {
    justify-content: space-between;
    
    div {
      width: 500px;
    }
  }
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0px 0px 15px 0px;
  padding: 0px;
  color: #000000;
  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  display: inline-block;
`;

export const UsersEmailListTitle = styled.p`
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.5rem !important;
`;

export const SelectedUsersEmailsListEmptyContainer = styled.div`
  border: 0.5px solid #d4d4d5;
  padding: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

export const SelectedUsersEmailsListEmptyText = styled.p`
  margin: 0 auto;
  font-size: 1rem;
  font-weight: 500;
  color: #d4d4d5;
`;

export const SelectedUsersEmailsListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.5rem;
  border: 0.5px solid #d4d4d5;
  padding: 0.75rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  max-height: 20rem;
  overflow-y: auto;
`;

export const SelectedUsersEmailsListItemIcon = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  padding: 0.25rem;
  margin-left: 0.25rem;
  color: inherit;

  &:hover {
    cursor: pointer;
    filter: brightness(0.9);
  }
`;

export const SelectedUsersEmailsListItem = styled.p`
  display: flex;
  align-items: center;
  margin: 0;
  background-color: #FF7417;
  padding: 0.25rem 0.8rem;
  color: #FFF;
  font-weight: 500;
  border-radius: 5rem;
`;

export const FileInputContainer = styled.div`
  margin-bottom: 0.5rem;
`;

export const FileInputLabel = styled.label`
  
`;

export const FileInput = styled.input`
  margin-top: 0.5rem !important;
`;

export const FileInputButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
